import './magnifier-control.scss';
import './magnifier-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/magnifier/index.js